module.exports = __webpack_public_path__ + "static/media/eggs-explore-more.c80a8df1.jpg";